import 'ol/ol.css';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import MapElement from "./MapElement";
import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Text from 'ol/style/Text';
import colors from 'dxf/src/util/colors';
import Featuredrawer from '../helpers/FeatureDrawer'

export default class MapCSVNumbers extends MapElement {
    constructor(map, id, mapElementSettings, parent) {
        super(map, id, mapElementSettings, parent)
    }

    drawLayer(data, projection, moduleSide) {
        this.drawCSVNumbersLayer(data, this.mapModel.dark, projection, this.mapModel.projection, moduleSide)

        if (this.parent && this.parent.layer) {
            this.parent.layer.getLayers().push(this.layer);
        }

        if (!this.mapElementSettings.defaultOn) {
            this.hide();
        }
    }
    drawCSVNumbersLayer(data, dark, projection, mapprojection, moduleSide, setting = null) { // used in previous taskinfo function
        var featureDrawer = new Featuredrawer(projection, mapprojection)

        var features = [];

        data.forEach(vertex => {
            if (vertex[1] != 'X1') {
                var feature = featureDrawer.drawFeature({ type: "POINT", x: Number(vertex[1]), y: Number(vertex[2]) })
                feature.set('name', vertex[0]);
                features.push(feature);
            }
        });
        var pointsSource = new VectorSource();
        pointsSource.addFeatures(features);

        this.layer = new VectorLayer({
            parentId: this.parent.id,
            source: pointsSource,
            style: function (feature, resolution) {
                var newScale = 0.1 / resolution;
                if (newScale > 9) {
                    newScale = 9;
                }
                var name = feature.get('name').trim();
                var color = colors[dark ? 7 : 0];
                var align = (moduleSide == "right" ? "left" : "right");
                var offset = (moduleSide == "right" ? newScale : -newScale);
                var style = new Style({
                    text: new Text({
                        text: name,
                        textAlign: align,
                        offsetX: offset,
                        scale: newScale,
                        fill: new Fill({
                            color: color,
                        }),
                    })
                });
                return style;
            },
            minZoom: 20,
            zIndex: 202,
        });
    }
}
